import { FormGroup } from 'reactstrap';
import LucideIcon from 'src/componentes/lucide-icon';

const View = (props) => {
  const isDisabled = props.disabled === true;

  return (
    <FormGroup
      className="popupOpen"
      style={{ marginBottom: '0 !important' }}
      noMargin={props.noMargin}
      validationstate={null}
    >
      <div
        style={{
          maxWidth: '50px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          opacity: isDisabled ? 0.5 : 1,
        }}
      >
        <LucideIcon
          size={props.size ?? 16}
          icon="MessageSquareText"
          style={{
            cursor: 'pointer',
            pointerEvents: isDisabled ? 'none' : 'auto',
          }}
          onClick={() => props.handleComentariosClick(props.valor)}
        />
        <span
          style={{
            backgroundColor: '#ddd',
            color: '#444343',
          }}
          className="badge"
        >
          {props.valor?.quantidadeComentarios}{' '}
        </span>
      </div>
    </FormGroup>
  );
};

export default View;
